import { usePostsFeatured } from '@gik/api/posts/postsFeatured';
import { BlogHomepage } from '@gik/blog/components/BlogHomepage/BlogHomepage';
import type Article from '@gik/blog/models/Article';
import WordpressConverter from '@gik/blog/utils/WordpressConverter';
import { DynamicComponent } from '@gik/core/components/DynamicComponent';
import type WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { ArticleHero } from '@gik/ui/gik/ArticleTile/ArticleTile';
import { PageSection } from '@gik/ui/gik/PageSection';
import React from 'react';

export interface IArticleHeroSectionProps {
  className?: string;
}

export function ArticleHeroSection({ className }: IArticleHeroSectionProps) {
  const bem = useBemCN('article-hero-section');

  return (
    <PageSection {...bem(null, null, className)}>
      <DynamicComponent<WordpressPost[], Article>
        height={300}
        fetch={function useFetch() {
          return usePostsFeatured({
            slug: 'learn-page-bottom-card',
            perPage: 1,
            fields: BlogHomepage.requiredWPFields.hero,
          });
        }}
        transform={posts =>
          posts.map(WordpressConverter.convertPost).filter(WordpressConverter.filterOutPreviewContent)[0]
        }
        loadingComponent={() => <ArticleHero {...bem('article-hero')} skeleton />}
      >
        {({ transformed: article }) => <ArticleHero {...bem('article-hero')} article={article} />}
      </DynamicComponent>
    </PageSection>
  );
}
